const coinBalanceReturnSyncRoutes = ['/ddoba', '/ttoba', '/coin'];

const isCoinBalanceReturnSyncRoute = (route) => {
    const path = route?.path || '';

    return coinBalanceReturnSyncRoutes.some((routePath) => {
        return path === routePath || path.startsWith(`${routePath}/`);
    });
};

export default {
    mounted() {
        if (
            typeof this.syncCoinBalanceOnReturn !== 'function' ||
            !isCoinBalanceReturnSyncRoute(this.$route)
        ) {
            return;
        }

        this.__coinBalanceReturnSyncHandler = () => {
            if (
                document.visibilityState === 'hidden' ||
                !isCoinBalanceReturnSyncRoute(this.$route)
            ) {
                return;
            }
            this.syncCoinBalanceOnReturn();
        };

        window.addEventListener('focus', this.__coinBalanceReturnSyncHandler);
        window.addEventListener('pageshow', this.__coinBalanceReturnSyncHandler);
        document.addEventListener('visibilitychange', this.__coinBalanceReturnSyncHandler);
    },
    beforeUnmount() {
        if (!this.__coinBalanceReturnSyncHandler) {
            return;
        }

        window.removeEventListener('focus', this.__coinBalanceReturnSyncHandler);
        window.removeEventListener('pageshow', this.__coinBalanceReturnSyncHandler);
        document.removeEventListener('visibilitychange', this.__coinBalanceReturnSyncHandler);
        this.__coinBalanceReturnSyncHandler = null;
    },
}
